import { Route, Routes } from 'react-router-dom'

import {
  ExcursionCustomerDetails,
  ExcursionFilters,
  ExcursionMainPage,
  ExcursionsByDirection,
  ExcursionsCalendarRangePage,
  ExcursionsContentPage,
  ExcursionsFilterGuides,
  ExcursionsGuidesDetail,
  ExcursionsOrderDetail,
  ExcursionsSearch,
  ExcursionsSearchDirections,
  ExcursionsSearchPage,
  MPlusExcursions,
  MyOrder,
  PopularDirection,
} from '..'

import { RoutingPaths } from 'app/routes/routes'

export const ExcursionPages = () => {
  return (
    <Routes>
      <Route
        path={RoutingPaths.excursion.start()}
        element={<ExcursionMainPage />}
      />
      <Route
        path={RoutingPaths.excursion.searchDirection.base()}
        element={<ExcursionsSearchDirections />}
      />
      <Route
        path={RoutingPaths.excursion.searchForm.base()}
        element={<ExcursionsSearchPage />}
      />
      <Route
        path={RoutingPaths.excursion.calendar.base()}
        element={<ExcursionsCalendarRangePage />}
      />
      <Route
        path={RoutingPaths.excursion.search.base()}
        element={<ExcursionsSearch />}
      />
      <Route
        path={RoutingPaths.excursion.filter.base()}
        element={<ExcursionFilters />}
      />
      <Route
        path={RoutingPaths.excursion.filterCarrier.base()}
        element={<ExcursionsFilterGuides />}
      />

      <Route
        path={RoutingPaths.excursion.mplus.base()}
        element={<MPlusExcursions />}
      />
      <Route
        path={RoutingPaths.excursion.guideDetail.base()}
        element={<ExcursionsGuidesDetail />}
      />
      <Route
        path={RoutingPaths.excursion.contentPage.base()}
        element={<ExcursionsContentPage />}
      />

      <Route
        path={RoutingPaths.excursion.orderDetail.base()}
        element={<ExcursionsOrderDetail />}
      />
      <Route
        path={RoutingPaths.excursion.customerDetails.base()}
        element={<ExcursionCustomerDetails />}
      />

      <Route
        path={RoutingPaths.excursion.popular.base()}
        element={<PopularDirection />}
      />
      <Route
        path={RoutingPaths.excursion.myOrder.detail.base()}
        element={<MyOrder />}
      />

      <Route
        path={RoutingPaths.excursion.excursionByDirection.base()}
        element={<ExcursionsByDirection />}
      />
    </Routes>
  )
}
